import ProfessionalHeader from '../../components/layout/Header';
import HeroSection from './hero';
import FeaturesSection from './features/FeaturesSection';
import TestimonialsSection from './TestimonialsSection';
import PricingSection from './PricingSection';
import FAQ from './faq';
import ContactForm from './contactform';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <ProfessionalHeader />

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <HeroSection />

        {/* Features Bento Grid */}
        <FeaturesSection />

        {/* Testimonials / Achievements */}
        <TestimonialsSection />

        {/* Pricing */}
        <PricingSection />

        {/* FAQ */}
        <FAQ />

        {/* Contact */}
        <ContactForm />
      </main>
    </div>
  );
};

export default HomePage;
